const copyPasteRequestStr = {
  toastr: 'Cut made',
  toastr1: 'Successfully cut'
};

export default copyPasteRequestStr;
